import { render, staticRenderFns } from "./RemoteConfig.vue?vue&type=template&id=2c534c96&scoped=true&"
import script from "./RemoteConfig.vue?vue&type=script&lang=js&"
export * from "./RemoteConfig.vue?vue&type=script&lang=js&"
import style0 from "./RemoteConfig.vue?vue&type=style&index=0&id=2c534c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c534c96",
  null
  
)

export default component.exports